module.exports = __webpack_public_path__ + "portal-static/img/image01.b097378e.jpg";